import { cssModules } from '@skyscanner-internal/backpack-web/bpk-react-utils';

import { TravelBetaLogo } from '../TravelBetaLogo/TravelBetaLogo';

import STYLES from './LogoFooter.module.scss';

const cls = cssModules(STYLES);

export const LogoFooter = () => (
  <section className={cls('logoFooter')}>
    <div className={cls('logoFooterInner')}>
      <TravelBetaLogo variant="footer" />
    </div>
  </section>
);
